export default __webpack_public_path__ + "static/media/VOTE_THANK_YOU.36fdcf93.png";